import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Router, Route, Link } from 'react-router-dom';
import history from '../history/browserHistory';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
} from '@material-ui/core';
import {
  ContactSupport as SupportIcon,
} from '@material-ui/icons';
import BillOfLading from './billOfLading/BillOfLading';
import SearchBillOfLading from './billOfLading/SearchBillOfLading';
import Messages from './common/Messages';
import { token } from '../auth/indentityAuth';
import { getUser } from '../selectors/selectors';
import logo from './NxtPort-IC.svg';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#008efd' },
  },
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: 'initial',
        paddingLeft: 8,
      },
    },
  },
});

const styles = theme => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundImage: 'linear-gradient(to right, #005efd, #009dfe)',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  logo: {
    marginLeft: 24,
    height: theme.spacing.unit * 5,
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing.unit * 4,
    },
  },
  navSeparator: {
    flex: 1,
  },
  navButton: {
    padding: '0 8px',
  },
});

class App extends React.Component {
  onLogout = () => {
    window.open(
      process.env.REACT_APP_IDENTITY_URL +
        'connect/endsession?id_token_hint=' +
        token.id_token +
        '&post_logout_redirect_uri=' +
        process.env.REACT_APP_CALLBACK_URL,
      '_self'
    );
  };

  onSupport = () => {
    window.open('https://nxtport.atlassian.net/servicedesk/customer/portal/1/create/1');
  };

  render() {
    const { user, classes } = this.props;

    return (
      <Router history={history}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <AppBar position="absolute" className={classes.appBar}>
            <Toolbar disableGutters className={classes.toolbar}>
              <Link to="/">
                <img alt="Import Consignment" src={logo} className={classes.logo} />
              </Link>
              <div className={classes.navSeparator} />
              <Typography className={classes.navButton} color="inherit" variant="button">
                {user.name}
              </Typography>
              <Button color="inherit" onClick={this.onLogout}>
                Logout
              </Button>
              <IconButton
                color="inherit"
                aria-label="Open support ticket"
                onClick={this.onSupport}
              >
                <SupportIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Route path="/:billOfLading/cn/:containerNumber" exact component={BillOfLading} />
          <Route path="/:billOfLading/sn/:vesselStay" exact component={BillOfLading} />
          <Route path="/" exact component={SearchBillOfLading} />
          <Messages />
        </MuiThemeProvider>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withStyles(styles)(App));
